import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {BookedFlowEndPoints} from 'main/factories/usecases/endpoints';
import {GetTelehealthDocs} from 'domain/usecases';
import {RemoteGetTelehealthDocs} from 'data/usecases';

export const makeGetAppointmentsTelehealthDocs = (): GetTelehealthDocs =>
	new RemoteGetTelehealthDocs(
		makeBFFApiUrl(BookedFlowEndPoints.appointmentsTelehealthDocs),
		makeAuthorizeHttpClientDecorator(),
	);
